<script lang="ts">
  import type { Place, Event, Map, EventHoursOccurrence } from "../../types";
  import { getNow, getTimeZone } from "../../data/clock";
  import { schedulePath, mapPath } from "../../support/links";
  import { getNextOpening } from "../../domain/events";
  import { displayOnMap } from "../../domain/map";
  import AppBar from "../app-bar.svelte";
  import AppBarAction from "../app-bar-action.svelte";

  export let timeZone = getTimeZone();
  export let time = getNow();
  export let places: Place[] = [];
  export let event: Event;
  export let map: Map;
  export let schedule: Array<EventHoursOccurrence>;

  $: hours = getNextOpening(schedule, $time, $timeZone);
  $: isOnMap = hours ? displayOnMap(map, places, hours.placeId, $time) : null;

  // Navigates to the closest event hours
  $: href = mapPath({
    event: event.id,
    place: hours ? hours.placeId : null
  });
</script>

<AppBar title={event.title} returnLink={schedulePath()}>
  {#if isOnMap}
    <AppBarAction label="nav.map" context="See event on map" icon="icon-locate" {href} />
  {/if}
</AppBar>
